import { Box, Link } from "@mui/material";
import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import "./InsurerCard.scss";

interface InsurerCardProps {
  productlogo?: string;
  insurerlogo?: string;
  eyes?: string;
  insurancetype?: string;
  heading1?: string;
  heading2?: string;
  heading3?: string;
  heading4?: string;
  spanheading1?: string;
  spanheading2?: string;
  spanheading3?: string;
  buttontextrenew?: string;
  buttonclass1?: string;
  buttonclass2?: string;
  buttontextactive?: string;
  buttonclassactive1?: string;
  buttonclassactive2?: string;
  value_update: Function;
  index:number
}
const InsurerCard: React.FC<InsurerCardProps> = ({
  productlogo,
  insurerlogo,
  eyes,
  insurancetype,
  heading1,
  heading2,
  heading3,
  heading4,
  spanheading1,
  spanheading2,
  spanheading3,
  buttontextrenew,
  buttonclass1,
  buttonclass2,
  buttontextactive,
  buttonclassactive1,
  buttonclassactive2,
  index,
  value_update,
}) => {
  return (
    <Box>
      <div className="insurance_card">
        <Grid container spacing={3}>
          <Grid xs={2}>
            <img src={productlogo} alt="" height={42} />
          </Grid>
          <Grid xs={6}>
            <h6>
              {insurancetype}
              <span>Insurance</span>
            </h6>
          </Grid>
          <Grid xs={4}>
            <img src={insurerlogo} alt="" height={57} />
          </Grid>
          <Grid xs={9}>
            <h5>
              <span>{spanheading1}</span>
              {heading1}
            </h5>
          </Grid>
          <Grid xs={3} className="text-right">
            <Link className={`${buttonclass1} ${buttonclass2}`}>
              {buttontextrenew}
            </Link>
          </Grid>
          <Grid xs={12} className="white_box">
            <ul className="inner_content">
              <li>
                <div className={`${buttonclassactive1} ${buttonclassactive2}`}>
                  {" "}
                  {buttontextactive}
                </div>
              </li>
              <li>
                <Link>
                  <img
                    src={eyes}
                    alt=""
                    height={20}
                    onClick={() => value_update("health" || "car", index)}
                  />
                </Link>
              </li>
              <li className="text">{heading2}</li>
            </ul>
          </Grid>

          <Grid xs={6} className="specification_box">
            <h6>
              {heading3} <span>{spanheading2}</span>
            </h6>
          </Grid>
          <Grid xs={6} className="specification_box text-right">
            <h6>
              {heading4} <span>{spanheading3}</span>
            </h6>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
};

export default InsurerCard;
